import { render } from "./DraaiboekView.vue?vue&type=template&id=2f783ef8"
import script from "./DraaiboekView.vue?vue&type=script&lang=js"
export * from "./DraaiboekView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__